import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Home.vue')
    }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/FAQ.vue')
    }
  },
  {
    path: '/manifesto',
    name: 'Manifesto',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Manifesto.vue')
    }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Terms.vue')
    }
  },
  {
    path: '/product/:url',
    name: 'Product',
    component: function () {
      return import('../views/Product.vue')
    }
  },
  {
    path: '/series/:url',
    name: 'Series',
    component: function () {
      return import('../views/Series.vue')
    }
  },
  {
    path: '/furniture',
    name: 'Furniture',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Furniture.vue')
    },
    children: [
      // UserHome will be rendered inside User's <router-view>
      // when /user/:id is matched
      { name:'FurnitureCategory', path: ':url', component: () => import('../views/FurnitureCategory.vue') },
      { name:'FurnitureCategoryNew', path: 'new', component: () => import('../views/FurnitureCategory.vue') },

      // ...other sub routes
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/materials/',
    name: 'Materials',
    component: () => import('../views/Materials.vue')
  },
  {
    path: '/materials/:material',
    name: 'Material',
    component: () => import('../views/Materials.vue')
  },
  {
    path: '/materials/:material/:id',
    name: 'MaterialDetail',
    component: () => import('../views/MaterialDetail.vue'),
  },
  {
    path: '/custom/about',
    name: 'CustomAbout',
    component: () => import('../views/Custom/About.vue'),
  },
  {
    path: '/custom/contact',
    name: 'CustomContact',
    component: () => import('../views/Custom/Contact.vue'),
  },
  {
    path: '/custom/designers/:url',
    name: 'CustomDesigner',
    component: () => import('../views/Custom/Designer.vue'),
  },
  {
    path: '/custom',
    name: 'Custom',
    component: () => import('../views/Custom/Index.vue'),
    children: [
      // UserHome will be rendered inside User's <router-view>
      // when /user/:id is matched
      { name: 'CustomCategory', path: 'category/:url', component: () => import('../views/Custom/Category.vue') },
      { path: 'designers', component: () => import('../views/Custom/Designers.vue') },

      // ...other sub routes
    ]
  },
  {
    path: '/custom/product/:url',
    name: 'CustomProduct',
    component: () => import('../views/Custom/Product.vue'),
  },
  {
    path: '/cs/',
    name: 'CS',
    component: () => import('../views/CS.vue'),
  },
  {
    path: '/cs/:url',
    name: 'CSCategory',
    component: () => import('../views/CS.vue'),
  },
  {
    path: '/cs/product/:url',
    name: 'CSProduct',
    component: () => import('../views/CSProduct.vue'),
  },
  {
    path: '/mosaic/',
    name: 'Mosaic',
    component: () => import('../views/Mosaic.vue'),
  },
  {
    path: '*',
    name: 'Not Found',
    component: () => import('../views/NotFound.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {

    console.log(to.name);

    console.log(from.name);
    
    if( !(to.name == 'CustomCategory' && from.name == 'Custom') || !(from.name == 'CustomCategory' && to.name == 'Custom')){

      if(!(from.name == 'Material' && to.name == 'Material')){
        return { x: 0, y: 0 }
      }
    }


    
  }
})

export default router
